<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
  <div fxFlex>Filter Options</div>
  <button mat-icon-button [mat-dialog-close]="false" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
    <form>
      <app-card title="Filter By Type" [collapsed]="false">
        <div class="form-group" style="text-align: right;">
          <div class="col" style="float: right;">
            <app-mat-simple-select [selectItems]="data.types" [(ngModel)]="filterType" [ngModelOptions]="{standalone: true}">
            </app-mat-simple-select>
          </div>
        </div>
      </app-card>
      <app-card title="Filter By Category" [collapsed]="false">
        <div class="form-group" style="text-align: right;">
          <div class="col" style="float: right;">
            <app-mat-simple-select [selectItems]="data.categories" [(ngModel)]="filterCategory" [ngModelOptions]="{standalone: true}">
            </app-mat-simple-select>
          </div>
        </div>
      </app-card>
      <app-card title="Filter By User" [collapsed]="false">
        <div class="form-group" style="text-align: right;">
          <div class="col" style="float: right;">
            <app-mat-simple-select [selectItems]="data.users" [(ngModel)]="filterUserId" [ngModelOptions]="{standalone: true}">
            </app-mat-simple-select>
          </div>
        </div>
      </app-card>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
</mat-dialog-actions>
